module.exports = __webpack_public_path__ + "static/media/p208model3.492bab8a.jpg";